export default {"src":"/_next/static/media/MAT.d3291108.svg","height":18,"width":18};